var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("DISABILITY")]),_c('h4',[_vm._v("An Illness or Injury and any symptoms, sequelae, or complication thereof requiring treatment. All injuries arising from the same event or series of continuous events are considered as one Disability.")])])
}]

export { render, staticRenderFns }